import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { JobPortalService } from 'src/app/services/job-portal.service';

@Component({
  selector: 'app-delete-location',
  templateUrl: './delete-location.component.html',
  styleUrls: ['./delete-location.component.css']
})
export class DeleteLocationComponent implements OnInit {

  locationList:any = [];
  id:any

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

  constructor(
    private toastr: ToastrService,
    private job_portal_service: JobPortalService) { }

  ngOnInit(): void {
    this.getAllLocation();
  }

  onTableDataChange(event: any) {
    this.totalRecords = event;
    this.getAllLocation();
  }

  getAllLocation(){
    this.job_portal_service.getAllLocation().subscribe(
      (res:any)=> {
        console.log(res)
        this.locationList = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  deleteLocation(){
    this.job_portal_service.deleteLocation(this.id).subscribe(
      (response:any)=>{
        this.toastr.success(response.message)
        this.getAllLocation();
        this.cancelModel();
      },
      (err:any)=>{
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  deleteIdSelect(id:any){
    this.id = id
  }

}

